
import { v4 as uuid } from "uuid";
import * as _ from "lodash";

export class SpotData {
    photos = [];
    groupId = null;
    notes = null;
    products = null;
    posMeta = null;
    groupMeta = null;

    constructor(posMeta, groupMeta) {
        this.groupId = groupMeta.id;
        this.posMeta = posMeta;
        this.groupMeta = groupMeta;
    }

    countValidProducts() {
        if (!this.products) {
            return 0;
        }
        let result = _.filter(this.products, data => {
            return data.checked === true;
        });
        return result.length;
    }

    countNotes() {
        if (!this.notes) {
            return 0;
        }
        return Object.keys(this.notes).length;
    }

    isValid(requiredImage = false, requiredSurvey = false, requiredProduct = false) {
        // Photos
        let index = _.findIndex(this.photos, function (o) {
            return o === null;
        });
        let isProcessingImage = index !== -1;
        let photoIsValid = this.photos.length > 0;
        let productsIsValid = this.countValidProducts() > 0;
        let notesIsValid = this.countNotes() > 0;

        if(isProcessingImage !== false){
            return false;
        }
        else if(!requiredImage && !requiredProduct && !requiredSurvey){
            return photoIsValid || productsIsValid || notesIsValid; // at least one should be filled
        }
        else {
            return (!requiredImage || photoIsValid)
                && (!requiredProduct || productsIsValid) 
                && (!requiredSurvey || notesIsValid)
        };
    }

    setProducts(products) {
        this.products = products;
    }

    setNotes(notes) {
        this.notes = notes;
    }

    createOrUpdatePhoto(photo) {
        if (photo) {
            let index = _.findIndex(this.photos, function (o) {
                return o === null;
            });
            if (index > -1) {
                this.photos[index] = { id: uuid(), data: photo };
            }
        } else {
            this.photos.push(null);
        }
    }

    removeInvalidPhoto() {
        let index = _.findIndex(this.photos, function (o) {
            return o === null;
        });
        if (index > -1) {
            this.photos.splice(index, 1);
        }
    }

    removePhoto(photo) {
        let index = _.findIndex(this.photos, function (o) {
            return o !== null && o.id === photo.id;
        });
        if (index > -1) {
            this.photos.splice(index, 1);
        }
    }

    generateOutput() {
        let products = [];
        _.each(this.products, (element, key) => {
            if (element.checked) {
                products.push({
                    ProductId: key,
                    Price: element.value
                });
            }
        });

        let answers = [];
        _.each(this.notes, (element, key) => {
            if (element instanceof Array) {
                _.each(element, internalData => {
                    let register: any = {
                        QuestionId: key
                    };
                    register.AnswerId = internalData;
                    answers.push(register);
                });
            } else if (element) {
                let register: any = {
                    QuestionId: key
                };

                if (typeof element === "string") {
                    register.Comments = element;
                    answers.push(register);
                } else if (typeof element === "object") {
                    for (var keyLoop in element) {
                        let register: any = {
                            QuestionId: key
                        };
                        // check also if property is not inherited from prototype
                        if (element.hasOwnProperty(keyLoop) && element[keyLoop] == true) {
                            register.AnswerId = parseInt(keyLoop);
                            answers.push(register);
                        }
                    }
                } else {
                    register.AnswerId = element;
                    answers.push(register);
                }
            }
        });
        let photos = this.photos.map(x => {
            return x.data;
        });
        return {
            POSId: this.posMeta.id,
            SpotProducts: products,
            groupId: this.groupId,
            Answers: answers,
            photos: photos
        };
    }
}

